import React, { useState, useEffect, useRef } from 'react';
import ZONES from '../../../../api/ressources/zones';

const LocationInput = ({ onPlaceSelected }) => {
  const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target) &&
          inputRef.current && !inputRef.current.contains(e.target)) {
        setSuggestions([]);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    if (inputValue.length < 1) {
      setSuggestions([]);
      setHasSearched(false);
      setSelectedIndex(-1);
      return;
    }

    const timeoutId = setTimeout(async () => {
      try {
        const response = await ZONES.autocomplete(inputValue);
        setSuggestions(response.data.results || []);
        setHasSearched(true);
        setSelectedIndex(-1);
      } catch (error) {
        console.error('Error fetching zones:', error);
        setHasSearched(true);
      }
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [inputValue]);

  const handleSelect = (zone) => {
    setInputValue('');
    setSelectedIndex(-1);

    if (onPlaceSelected) {
      onPlaceSelected(zone);
    }
  };

  const handleKeyDown = (e) => {
    if (suggestions.length === 0) return;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setSelectedIndex((prev) =>
          prev < suggestions.length - 1 ? prev + 1 : prev
        );
        break;
      case 'ArrowUp':
        e.preventDefault();
        setSelectedIndex((prev) => prev > 0 ? prev - 1 : -1);
        break;
      case 'Enter':
        e.preventDefault();
        if (selectedIndex >= 0 && selectedIndex < suggestions.length) {
          handleSelect(suggestions[selectedIndex]);
        }
        break;
      case 'Escape':
        setSuggestions([]);
        setSelectedIndex(-1);
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <input
        ref={inputRef}
        type='text'
        name='zones'
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
        }}
        onKeyDown={handleKeyDown}
        className='vesta-input vesta-autocomplete'
        placeholder='Entrez une ville, un arrondissement...'
        autoComplete='off'
      />

      {suggestions.length > 0 && (
        <div ref={dropdownRef} className='vesta-location-autocomplete-dropdown'>
          {suggestions.map((zone, index) => (
            <div
              key={`${zone.type}-${zone.id}`}
              onClick={() => handleSelect(zone)}
              className={`vesta-location-autocomplete-item ${index === selectedIndex ? 'vesta-location-autocomplete-item-selected' : ''}`}
            >
              {zone.type === 'City' ? (
                <>
                  <div className='vesta-location-autocomplete-item-name'>
                    {zone.name}
                  </div>
                  {zone.zip_code && <div className='vesta-location-autocomplete-item-zipcode'>{zone.zip_code}</div>}
                </>
              ) : (
                <>
                  <div className='vesta-location-autocomplete-item-name'>
                    {zone.name}
                  </div>
                  <div className='vesta-location-autocomplete-item-city'>
                    {zone.city_name} {zone.zip_code}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      )}

      {hasSearched && suggestions.length === 0 && inputValue.length >= 4 && (
        <p className='vesta-location-autocomplete-empty'>
          Nous ne couvrons pas encore cette zone
        </p>
      )}
    </div>
  );
};

export default LocationInput;
